module.exports = __webpack_public_path__ + "img/0.29463b20.png";